import styled from 'styled-components';

import { Marker } from '@xing-com/marker';
import { spaceS, spaceXS } from '@xing-com/tokens';

const FactsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${spaceXS};
  max-height: 112px;
  overflow: hidden;
`;

const Item = styled(Marker)`
  margin-right: ${spaceS};
  margin-bottom: ${spaceS};
`;

export { FactsContainer, Item };
